
import { createCometExplosionAnimation } from "./cometExplosion";
import {AnimationFactory, AnimationName} from "../types";
import {createLightningDischargeAnimation} from "./Lighting";
import {createBlessingBuffAnimation} from "./BlessingBuff";
import {createCurseDebuffAnimation} from "./CurseDebuff";
import {createMassDestroyAnimation} from "./MassDestroy";
import {createChainLightningAnimation} from "./ChainLightning";
import {createTentaclesAnimation} from "./Tentacles";
import {createBloodChainAnimation} from "./BloodChain";
import {createPlagueAnimation} from "./Plague";


export const animationsRegistry: Record<AnimationName, AnimationFactory> = {
    cometExplosion: createCometExplosionAnimation,
    Lighting: createLightningDischargeAnimation,
    BlessingBuff: createBlessingBuffAnimation,
    CurseDebuff: createCurseDebuffAnimation,
    MassDestroy: createMassDestroyAnimation,
    ChainLightning:createChainLightningAnimation,
    Tentacles:createTentaclesAnimation,
    BloodChain: createBloodChainAnimation,
    Plague: createPlagueAnimation,
};

export * from "../types";